export default {
  name: "名称1",
};
